/* Arima Homewares | benefit-led Zoorix cross-sell headings, Cyber26.
   Keeps original product mappings, 3+ cards, discounts, prices, cart buttons untouched. */
(function(){
  'use strict';
  var originals = /^(Frequently Bought Together|Click to add)$/i;
  function chooseCopy() {
    var p=window.__arimaZoorixSource || {};
    var source=((p.title||'')+' '+(p.type||'')+' '+(p.vendor||'')).toLowerCase();
    if(/miyabi|w[uü]sthof|victorinox|chef.s knife|paring knife|santoku|knife|knives|blade|sharpen/.test(source))
      return {title:'LOOK AFTER YOUR KNIVES & SAVE! 🔪',
        subtitle:'Make prep and knife care easier with useful companions — and enjoy genuine sale savings.'};
    if(/cookware|pan|casserole|staub|scanpan|pot|skillet|wok/.test(source))
      return {title:'MAKE COOKING EASIER — FOR LESS! 🍳',
        subtitle:'Pair your cookware with useful kitchen essentials to help you make the most of every meal.'};
    if(/baking|bakeware|cake tin|loaf|muffin|baking tray/.test(source))
      return {title:'GET READY FOR YOUR NEXT BAKE & SAVE! 🍰',
        subtitle:'Add practical tools that make measuring, mixing and baking easier.'};
    if(/cutlery|stanley rogers|tableware|dining|glassware|plate|flatware/.test(source))
      return {title:'SET THE TABLE BEAUTIFULLY — FOR LESS! 🍽️',
        subtitle:'Bring your table together with complementary dining and serving favourites.'};
    if(/coffee|espresso|kettle|tea|mug|cup|brew/.test(source))
      return {title:'MAKE EVERY CUP A LITTLE BETTER! ☕',
        subtitle:'Explore helpful accessories to complement your coffee and tea favourites.'};
    if(/storage|container|lunch|food prep/.test(source))
      return {title:'PREP, STORE & SAVE! 🥣',
        subtitle:'Keep your kitchen organised with practical extras to complement your purchase.'};
    return {title:'MORE USEFUL KITCHEN DEALS! 🎉',
      subtitle:'Get more out of your purchase with practical kitchen and home companions.'};
  }
  function amount(s){
    var m=String(s||'').replace(/,/g,'').match(/\d+(?:\.\d+)?/);
    return m ? Number(m[0]) : 0;
  }
  function allCardsOnSale(widget){
    var cards=Array.from(widget.querySelectorAll('.zrx-slider-list-item'));
    if(!cards.length) return false;
    return cards.every(function(card){
      var current=card.querySelector('.zrx-slider-product-price.zrx-regular');
      var before=card.querySelector('.zrx-slider-product-price.zrx-compare');
      return Boolean(before&&current&&amount(before.textContent)>amount(current.textContent)&&amount(current.textContent)>0);
    });
  }
  var processing=false;
  function apply(){
    if(!document.body||!document.body.classList.contains('template-product')) return;
    var data=chooseCopy();
    document.querySelectorAll('.zrx-frequently-bought-together.zrx-upsell').forEach(function(widget){
      var wrapper=widget.querySelector('.zrx-slider-title-wrapper');
      if(!wrapper) return;
      var title=wrapper.querySelector('.zrx-slider-main-title');
      var subtitle=wrapper.querySelector('.zrx-slider-sub-title');
      if(!title||!subtitle) return;
      // No claim of sale unless every recommendation shown has a verified markdown.
      var onsale=allCardsOnSale(widget);
      var headline=onsale ? data.title : data.title.replace(/\s*&\s*SAVE!|\s*—\s*FOR LESS!|\s*DEALS!/g,'!');
      var detail=onsale ? data.subtitle : data.subtitle.replace(/\s*—\s*and enjoy genuine sale savings\./,'.');
      if(title.textContent!==headline) title.textContent=headline;
      if(subtitle.textContent!==detail) subtitle.textContent=detail;
      if(!widget.classList.contains('arima-zoorix-reasons-active'))
        widget.classList.add('arima-zoorix-reasons-active');
    });
  }
  var scheduled=false;
  function schedule(){
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(function(){scheduled=false;apply();});
  }
  function start(){
    if(!document.body||!document.body.classList.contains('template-product'))return;
    if(window.__arimaZoorixWhyInstalled)return;
    window.__arimaZoorixWhyInstalled=true;
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
    schedule();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
